'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  FRIENDS_QUERY_KEY,
  FRIENDS_TAB_COUNTS_QUERY_KEY,
  RECEIVED_REQUESTS_QUERY_KEY,
} from '@/modules/players/v3/constants/friends';
import { RELATIONSHIP_QUERY_KEY } from '@/modules/players/v3/hooks/use-get-relationship';
import { acceptFriendRequest } from '@/utils/actions/players/friends/acceptFriendRequest';

export interface UseAcceptFriendRequestParams {
  uuid: string;
  friendUuid: string;
}

export const useAcceptFriendRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ uuid, friendUuid }: UseAcceptFriendRequestParams) => {
      const res = await acceptFriendRequest({ uuid, friendUuid });
      if (res.error) {
        throw new Error(`Failed to accept friend request: ${res.error}`);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FRIENDS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [RECEIVED_REQUESTS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [FRIENDS_TAB_COUNTS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [RELATIONSHIP_QUERY_KEY] });
    },
  });
};
